import { KeyWordLandingPage } from '../../types';
import { MetaDataContext } from './types';

type Props = {
  data: {
    keywordLandingPage: KeyWordLandingPage;
  };
};

export default ({ data }: Props, { market, t }: MetaDataContext) => {
  if (!data || !data.keywordLandingPage) {
    return {};
  }

  const {
    url,
    searchResults,
    title,
    categories,
    inSitemap,
    parentCategory,
  } = data.keywordLandingPage;

  const canonical = market.domain + url;
  const noIndex = !inSitemap;
  const breadcrumb = parentCategory?.path;
  const { results } = searchResults ?? {};
  const newLayoutDescription =
    results && results.categories
      ? results.categories.nodes.map(category => category?.name).join(' ')
      : '';

  return {
    title: t('meta', 'keyword-search-page.title', {
      keyword: title[0].toUpperCase() + title.slice(1),
    }),
    description:
      (categories && categories?.length > 0) ||
      (results?.categories && results?.categories?.nodes?.length > 0)
        ? t('meta', 'keyword-search-page.description', {
            keyword: title[0].toUpperCase() + title.slice(1),
            categories: categories
              ? categories?.map(({ name }) => name).join(' ')
              : newLayoutDescription,
          })
        : t('meta', 'keyword-search-page.description-offers-only', {
            keyword: title[0].toUpperCase() + title.slice(1),
          }),
    canonical,
    noIndex,
    breadcrumb,
  };
};
